import { Close } from '@mui/icons-material'
import { CircularProgress } from '@mui/material'
import { ReactElement, useMemo, useState } from 'react'
import { defaultTheme } from 'src/theme'
import styled from 'styled-components'

interface Props {
  file: File
  setFile: (file: File) => void
}

const fileSizeConversion = (bytes: number, decimals = 2) => {
  if (bytes === 0) return '0 B'

  const kiloByte = 1000
  const decimal = decimals < 0 ? 0 : decimals
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i: number = Math.floor(Math.log(bytes) / Math.log(kiloByte))

  return `${parseFloat((bytes / kiloByte ** i).toFixed(decimal))} ${sizes[i]}`
}

const FileSelected = (props: Props): ReactElement => {
  const { file, setFile } = props

  const [loading] = useState(false) // TODO: handle later
  const fileSize = useMemo(() => fileSizeConversion(file.size), [file.size])

  const handleRemove = (): void => {
    setFile(null)
  }

  return (
    <SelectedFileContainer>
      <FileSizeContainer>
        <StyledText>{`${file.name} (${fileSize})`}</StyledText>
        {!loading && (
          <Close
            style={{ color: '#0F172A', cursor: 'pointer' }}
            onClick={handleRemove}
          />
        )}
      </FileSizeContainer>
      {loading && (
        <CircularProgress
          style={{
            marginLeft: '15px',
            marginRight: '15px',
            color: defaultTheme.colors.primary,
          }}
        />
      )}
    </SelectedFileContainer>
  )
}

const SelectedFileContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  height: 429px;
`

const FileSizeContainer = styled.div`
  display: flex;
  flex-direction: row;
  border: 1px solid black;
  border-radius: 5px;
  justify-content: space-between;
  align-items: center;
  padding: 25px;
  width: 616px;
  background-color: whitesmoke;
`

const StyledText = styled.span`
  font-size: 14px;
  font-family: Roboto, serif;
  color: black;
  font-weight: bold;
  display: block;
  text-align: left;
`

export default FileSelected
